var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08014 8.51999C8.03348 8.51332 7.97348 8.51332 7.92014 8.51999C6.74681 8.47999 5.81348 7.51999 5.81348 6.33999C5.81348 5.13332 6.78681 4.15332 8.00014 4.15332C9.20681 4.15332 10.1868 5.13332 10.1868 6.33999C10.1801 7.51999 9.25348 8.47999 8.08014 8.51999Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 12.92C11.3068 14.0067 9.7335 14.6667 8.00017 14.6667C6.26684 14.6667 4.6935 14.0067 3.50684 12.92C3.5735 12.2934 3.9735 11.68 4.68684 11.2C6.5135 9.98671 9.50017 9.98671 11.3135 11.2C12.0268 11.68 12.4268 12.2934 12.4935 12.92Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 14.6666C11.6821 14.6666 14.6668 11.6818 14.6668 7.99992C14.6668 4.31802 11.6821 1.33325 8.00016 1.33325C4.31826 1.33325 1.3335 4.31802 1.3335 7.99992C1.3335 11.6818 4.31826 14.6666 8.00016 14.6666Z",
    stroke: "#0D1116",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.b2a7adda31506bc96157a2aff540c6f2.svg";
export { ForwardRef as ReactComponent };